// removed by extract-text-webpack-plugin
module.exports = {"blue":"_7XA6wjX7Q-UdpEEoxtU-7","sky-blue":"#54bfff","dark-red":"#a30000","red":"_1THL9xGHWot-2hWpPDcBry","dark-orange":"#b55808","orange":"_29l2L-UQnWi80GuE5-8FLd","dark-green":"#008300","dark-purple":"#4a2e5e","black":"yCC1sWiEffsnMUxK1xU2e","badge":"_5b-Kk0QJPvu8Xzx8GvHnF","green":"LRRDaWUh8SEu8M2xbS-tp","purple":"_1lkguFjZMx2kj2xxJoz24A"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Badges/Badge.css
// module id = 879
// module chunks = 0